import { apiUrl } from '../../../settings'

export const getDashboardCountUrl = () => {
  return `${apiUrl}/api/getDashboardCount`
}
export const getNewDashboardCountUrl = () => {
  return `${apiUrl}/api/getNewDashboardStats`
}